<template>
  <div class="home-inovations">
    <img class="desktop" src="../../assets/img/home/inovations/bg.jpg">
    <img class="mobile" src="../../assets/img/home/inovations/bg_m.jpg">
    <div class="text-group">
      <h3 class="text-accent">{{ $t('home-innovations-1') }}</h3>
      <h1>{{ $t('home-innovations-2') }}</h1>
      <h2>
        {{ $t('home-innovations-3') }}
        <br>
        {{ $t('home-innovations-4') }}
      </h2>
      <router-link to="/sustainability" class="link">
        <span class="text-main-home">{{ $t('learn-more') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.home-inovations {
  position: relative;
  img {
    display: block;
    height: auto;
    width: 100%;
  }
  .text-group {
    position: absolute;
    top: 5%;
    left: 15%;
    min-width: 800px;
    width: 40%;
  }
  .mobile {
    display: none;
  }
}
@media screen and (max-width: 1280px) {
  .home-inovations {
    .text-group {
      top: 10%;
      min-width: 500px;
    }
  }
}
@media screen and (max-width: 1000px) {
  .home-inovations {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .text-group {
      left: 0;
      min-width: initial;
      padding: 0 $sidesPadding1280;
      top: 10%;
      width: 100%;
    }
  }
}
@media screen and (max-width: 600px) {
  .home-inovations {
    .text-group {
      padding: 0 $sidesPadding600;
    }
  }
}
</style>

